import React, { useState, useEffect } from 'react';
import { IonIcon } from '@ionic/react';
import { eye, eyeOff } from 'ionicons/icons';
import ErrorLoggingService from '../service/ErrorLoggingService';

/**
 * PHI Masking Component (SRS-WEB-029, SRS-WEB-030, SRS-WEB-031)
 * Masks PHI fields by default and provides reveal control with audit logging
 */
const PHIMask = ({ 
  value, 
  fieldType, 
  patientId, 
  userId,
  className = "",
  style = {},
  authorized = true // RBAC check - only authorized users can reveal
}) => {
  const [isRevealed, setIsRevealed] = useState(false);

  // Auto re-mask on component unmount (SRS-WEB-030)
  useEffect(() => {
    return () => {
      if (isRevealed) {
        setIsRevealed(false);
      }
    };
  }, [isRevealed]);

  // Auto re-mask on page navigation/refresh (handled by parent component)

  const maskValue = (val) => {
    if (!val || val.length === 0) return '';
    if (val.length <= 4) return '****';
    return '****' + val.slice(-4); // Show last 4 characters
  };

  const handleReveal = () => {
    if (!authorized) {
      ErrorLoggingService.warn("Unauthorized PHI reveal attempt", {
        fieldType,
        patientId,
        userId
      });
      return;
    }

    const wasRevealed = isRevealed;
    setIsRevealed(!isRevealed);

    // Log reveal/hide action (SRS-WEB-031) - log every time user reveals or hides
    if (!wasRevealed) {
      // User is revealing (was hidden, now showing)
      ErrorLoggingService.info("PHI reveal action", {
        action: "reveal",
        fieldType,
        patientId: patientId || null,
        userId: userId || null,
        timestamp: new Date().toISOString()
      });
    } else {
      // User is hiding (was shown, now hiding)
      ErrorLoggingService.info("PHI hide action", {
        action: "hide",
        fieldType,
        patientId: patientId || null,
        userId: userId || null,
        timestamp: new Date().toISOString()
      });
    }
  };

  if (!value) return <span className={className} style={style}>-</span>;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span className={className} style={style}>
        {isRevealed && authorized ? value : maskValue(value)}
      </span>
      {authorized && (
        <IonIcon
          icon={isRevealed ? eyeOff : eye}
          onClick={handleReveal}
          style={{
            cursor: 'pointer',
            fontSize: '18px',
            color: isRevealed ? '#2196f3' : '#666'
          }}
          title={isRevealed ? 'Hide' : 'Reveal'}
        />
      )}
    </div>
  );
};

export default PHIMask;

